// extracted by mini-css-extract-plugin
export default {"containprod":"zA","containprod2":"AA","title":"BA","servings":"CA","recommendation":"EA","image":"FA","flavorswrap":"GA","flavorsgroupwrap":"HA","moredetailsWrap":"IA","infoWrap":"JA","price":"KA","regularPrice":"LA","netPrice":"MA","addtocartcontainer":"NA","error":"OA"};
    if(module.hot) {
      // 1714442369224
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  